import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap'
import { BranchItems } from '../components/BranchItems';
import { inject, observer } from 'mobx-react';
import { AlertGenerator } from '../components/AlertGenerator';

@inject('configurationStore')
@observer
class Branches extends Component {
  displayName = Branches.name;

  componentDidMount() {
    const currentCustomerId = parseInt(this.props.match.params.customerId, 10);
    this.props.configurationStore.setCurrentCustomerId(currentCustomerId);
    this.props.configurationStore.getBranches();
  }
  
  render() {
    const { configurationStore, } = this.props;
    if (configurationStore.isLoading)
      return <p><em>Loading...</em></p>;

    const { 
      hasNewBranch,
      updateBranchItem,
      addNewBranch,
      saveBranchItem,
      branches,
      customer
    } = configurationStore;

    const { alertMessage, hideAlert } = configurationStore;
        
    
    return (
      <div>
        <AlertGenerator alertMessage={alertMessage} hideAlert={hideAlert}></AlertGenerator>
        <h1>{customer.name} - Branches</h1>
        <Link to={`/customer/${customer.id}`} className="mr-5">
            <Glyphicon glyph="arrow-left" /> Back to Customer
        </Link>
        <hr></hr>
        <BranchItems items={branches} hasNewBranch={hasNewBranch} updateBranchItem={updateBranchItem} addNewBranch={addNewBranch} saveBranchItem={saveBranchItem} />
      </div>
    );
  }
}

export { Branches };